import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../template/layout/core'
import {ListCDRPage} from './ListCDRPage'

const CDRWrapper: FC = () => {
  const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'APPS.CDR'})}</PageTitle>
      <ListCDRPage />
    </>
  )
}

export {CDRWrapper}
